import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoadingController, ToastController, AlertController, PopoverController, MenuController, ModalController } from '@ionic/angular';
import * as XLSX from 'xlsx';
import { NegarPage } from "../app/components/negar/negar.page";
import { EditEmpPage } from "../app/components/edit-emp/edit-emp.page";
import { DatePipe, CurrencyPipe } from '@angular/common';


import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  HTTPoptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': environment.Authorization
    })
  };

  editarHotel;
  showTitle = true; timeShowTitle = 50;
  title = "";
  subtitle = "";
  apiOnReq = false;
  loading;
  temporizador;

  cedulasString = "";
  cedulasExist: any[] = [];
  cedulasNotFound = [];
  cedulasNotFoundString = ""
  Liq = [];
  filtLiq = [];
  busqueda1 = "";
  busqueda2 = "";
  busqueda3 = "";
  busqueda4 = "";

  busqueda8 = "";
  usersForLiq = [];
  count = 0;
  descarga;
  descargaShow = false;
  generarShow = false;

  login = false;
  user: any;
  correo = "";
  usuario = "";
  clave = "";
  ClientesConv = [];
  ClientesConvFilt = [];

  uploadFileValue;

  pagShowOp = false;
  pagShowLiq = false;
  usuarioShowOp = false;

  empresas1 = [];
  empresasGrupo = [];
  /* empresasMTI = [
      {IdEmpresa: 900011545, Nombre: "MANEJO TECNICO DE LA INFORMACION MTI" }
     ,{IdEmpresa: 830215592, Nombre: "THOMAS GREG EXPRESS S.A"}
     ,{IdEmpresa: 830014193, Nombre: "THOMAS GREG SEGURIDAD INTEGRAL LTDA"}
     ,{IdEmpresa: 860005080, Nombre: "THOMAS GREG SONS DE COLOMBIA"}
     ,{IdEmpresa: 830012157, Nombre: "THOMAS GREG SONS LIMITED"}
     ,{IdEmpresa: 900966568, Nombre: "THOMAS PROCESING SYSTEMS SAS"}
  ] */

  hisLiq = [];
  filtHisLiq = [];

  allSol = [];
  pendSol = [];
  filtPendSol = [];
  hisSol = [];
  filtHisSol = [];
  spinnerEn = false;
  spinnerResEn = false;
  enviando = false;

  enBtnEnvAprob = false;

  solRechazo;
  motivoRechazo = "Otros";

  respuestas = [];

  estados;

  showDetReporte = false;
  EncReportes = [];
  EncReportesFilt = [];

  apibusy = false;
  IdEmpresa = 0;
  AdminViajes = 0
  Correo = '';

  encReporte: any = [];
  DetReporte = [];
  DetReporteFilt = [];
  busqueda9 = "";
  modoRecarga = '';

  banner: {
    Ord: any; Link: string; Img: string; Titulo?: string; Descripcion?: string; BtnText?: string 
}[] = []
  firebaseConfig = {
    apiKey: "AIzaSyC9jqc2BhoOxw6CJHcJl04e6LvPhdAfNEk",
    authDomain: "bannersdenario.firebaseapp.com",
    projectId: "bannersdenario",
    storageBucket: "bannersdenario.appspot.com",
    messagingSenderId: "440630798578",
    appId: "1:440630798578:web:79b718d374ef2218e8486b",
    measurementId: "G-Z3H38QTGXD"
  };
  appFirebase;

  viajesPendientes = [];
  viajesPendientesFilt = [];

  viajesPendientesBerge = [];
  viajesPendientesFiltBerge = [];
  infoConv;

  arregloHoteles = [];
  arregloHotelesFilt = [];

  bancos;

  EmpToEdit;

  credPagare: any;

  empleadoXeditar;
  constructor(
    public http: HttpClient,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public router: Router,
    public menu: MenuController,
    public alertController: AlertController,
    public popoverController: PopoverController,
    public modalController: ModalController,
    public datePipe: DatePipe,
    public currencyPipe: CurrencyPipe
  ) {
    this.init();
  }

  async init() {
    this.router.navigate(['/dashboard']);
    await Storage.get({ key: 'loginNewConvDen' })
      .then(async (res) => {
        console.log('Storageget: ', res);
        let resJSON = JSON.parse(res.value);
        console.log('resJSON: ', resJSON);
        if (resJSON) {
          this.login = resJSON.login;
          const userName = resJSON.user;
          console.log("userName: ", userName);
          this.user = await this.getUser(userName);
          console.log({ DATADOS: await this.getUser(userName) })
          console.log('user: ', this.user);
          if (this.user.convenios != null && this.user.convenios != '') { this.empresasGrupo = JSON.parse(this.user.convenios); console.log(this.empresasGrupo); }
          if (this.user) {
            console.log('IdEmpresa: ', this.user.IdEmpresa);
            this.IdEmpresa = this.user.IdEmpresa;
            this.Correo = this.user.Correo;
            /* this.checkPath(); */
            this.getModoRecarga();
            this.getEmpresas1();
            this.getEstados();
            this.getCodBancos();
            this.getBanner();
            this.getConvInfo();
            /* this.getAllSol(); */
            /* this.getClientesForConv(); */
          } else {
            this.logOut();
          }
        }
      })
      .catch((err) => {
        console.log('error Storageget: ', err);
      });
    if (!this.login) { this.router.navigate(['/login']); }
  }

  async getUser(userName: string) {
    let user: any;
    const body = { usuario: userName }
    await this.req('post', 'convenio/getUser', body, 'Obteniendo usuario...')
      .then((response: any) => {
        user = response.usuario
      })
      .catch((error) => {
        this.presentAlert('Error', 'Al obtener usuario', JSON.stringify(error));
      })
    return user;
  }

  checkPath() {
    let initPathArr = window.location.href.split('/');
    let initPath = initPathArr[3];
    console.log(initPathArr);
    console.log('current url: ', initPath);
    switch (initPath.toLowerCase()) {
      case 'viajes-pendientes':
        this.router.navigate(['/viajes-pendientes']);
        break;
      case 'historial-puntos':
        this.router.navigate(['/historial-puntos']);
        break;
      case 'distribuir-puntos':
        this.router.navigate(['/distribuir-puntos']);
        break;
      default:
        console.log(window.location.href);
        this.router.navigate(['/dashboard']);
        break;
    }
  }

  async getEmpresas1() {
    console.log('Obteniendo empresas1...');
    /* await this.presentLoading('Obteniendo información de pagos...');
    this.apiOnReq = true; */
    /* let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }; */
    let body = {};
    this.http.post(environment.urlApi + 'getempresas1', body).subscribe((res: any) => {
      this.empresas1 = res.tabla;
      this.empresas1.push({
        IdEmpresa: 0,
        Nombre: 'Todas'
      })
      console.log('empresas1: ', this.empresas1);
      let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == this.user.IdEmpresa);
      this.user.Empresa = empresa.Nombre.trim();
      console.log('Empresa: ', this.user.Empresa);
      /* this.loading.dismiss();
      this.apiOnReq = false; */
    })
  }

  openCustom() {
    // this.menu.enable(true, 'custom');
    // this.menu.open('custom');
    return
  }

  openLoginMenu() {
    // this.menu.enable(true, 'end');
    // this.menu.open('end');
    return
  }

  pagShow() {
    if (this.pagShowOp) { this.pagShowOp = false; } else { this.pagShowOp = true; }
  }

  liqShow() {
    if (this.pagShowLiq) { this.pagShowLiq = false; } else { this.pagShowLiq = true; }
  }

  usuarioShow() {
    this.usuarioShowOp = !this.usuarioShowOp
  }

  segVerviajesGlobal = false
  ViajesConvenio() {
    if (this.segVerviajesGlobal) { this.segVerviajesGlobal = false } else { this.segVerviajesGlobal = true }
  }

  segVerViajes = false;
  verViajes() {
    if (this.segVerViajes) { this.segVerViajes = false; } else { this.segVerViajes = true; }
  }

  segVerViajes2 = false;
  verViajes2() {
    if (this.segVerViajes) { this.segVerViajes = false; } else { this.segVerViajes = true; }
  }


  segVerViajesBerge = false;
  verViajesBerge() {
    if (this.segVerViajesBerge) { this.segVerViajesBerge = false; } else { this.segVerViajesBerge = true; }
  }

  segVerViajesSecuritas = false;
  verViajesSecuritas() {
    if (this.segVerViajesSecuritas) { this.segVerViajesSecuritas = false; } else { this.segVerViajesSecuritas = true; }
  }

  segVerViajesBureauVeritas = false;
  verViajesBureauVeritas() {
    if (this.segVerViajesBureauVeritas) { this.segVerViajesBureauVeritas = false; } else { this.segVerViajesBureauVeritas = true; }
  }

  segVerViajesBrm = false;
  verViajesBrm() {
    if (this.segVerViajesBrm) { this.segVerViajesBrm = false; } else { this.segVerViajesBrm = true; }
  }

  segVerViajesPremise = false;
  verViajesPremise() {
    if (this.segVerViajesPremise) { this.segVerViajesPremise = false; } else { this.segVerViajesPremise = true; }
  }

  segVerViajesQuick = false;
  verViajesQuick() {
    if (this.segVerViajesQuick) { this.segVerViajesQuick = false; } else { this.segVerViajesQuick = true; }
  }

  segVerViajesColtugs = false;
  verViajesColtugs() {
    if (this.segVerViajesColtugs) { this.segVerViajesColtugs = false; } else { this.segVerViajesColtugs = true; }
  }

  irPendAprob() {
    this.menu.close('custom')
    this.router.navigate(['/pendaprobacion']);
  }

  irSolsPendientes() {
    this.menu.close('custom')
    this.router.navigate(['/aprobacion-interna-creditos']);
  }

  irHisAprob(preFilter = [2, 3, 5, 7, 10]) {
    this.estadosSelectValue = preFilter;
    this.menu.close('custom')
    this.router.navigate(['/hisaprobacion']);
  }

  irLiquidaciones() {
    this.menu.close('custom')
    this.router.navigate(['/liquidaciones']);
  }

  irHisLiquidaciones() {
    this.menu.close('custom')
    this.router.navigate(['/hisliquidaciones']);
  }

  irReportes() {
    this.menu.close('custom')
    this.router.navigate(['/reportes']);
  }

  irDashboard() {
    this.menu.close('custom')
    this.router.navigate(['/dashboard']);
  }

  irUsuariosSuperAdmin() {
    this.menu.close('custom')
    this.router.navigate(['/usuarios-superadmin']);
  }

  verUsuarios() {
    this.menu.close('custom')
    this.router.navigate(['/ver-usuarios']);
  }

  crearUsuarios() {
    this.menu.close('custom')
    this.router.navigate(['/registrar-usuarios']);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: mensaje
    });
    await this.loading.present();
    this.temporizador = setTimeout(() => {
      if (this.apiOnReq) {
        this.loading.dismiss();
        this.apiOnReq = false;
        console.log('Mucho tiempo esperando respuesta del api');
      }
    }, 30000);
  }

  async presentToast(mensaje, color = 'primary') {
    const toast = await this.toastController.create({
      message: mensaje,
      position: "bottom",
      duration: 2000,
      color: color,
      mode: 'ios',
      cssClass: "toast"
    });
    toast.present();
  }
  async presentToastMiddle(mensaje, color = 'primary') {
    const toast = await this.toastController.create({
      message: mensaje,
      position: "middle",
      duration: 2000,
      color: color,
      mode: 'ios',
      cssClass: "toast"
    });
    toast.present();
  }

  ExcelToJson(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        let workBook: any;
        const data = reader.result;
        let res: any;
        workBook = XLSX.read(data, { type: 'binary' });
        res = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        resolve(res);
      }
      reader.readAsBinaryString(file);
    })
  }

  async presentAlert(titulo, subtitulo, mensaje) {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: titulo,
      subHeader: subtitulo,
      message: mensaje,
      buttons: ['OK']
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  exportAsExcelFile(json: any[], nombre: string) {
    let fecha = new Date();
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate() + '_' + fecha.getHours() + '-' + fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombre);
    XLSX.writeFile(wb, nombre + '_' + fechaForm + '.xlsx');
  }





  exportAsExcelFile2(json: any[], nombre: string) {
    let fecha = new Date();
    let file = [];
    json.forEach(ele => {
      let producto;
      if (ele.Tipo == "D") {
        producto = "DINERO"
      } else if (ele.Tipo == "P") {
        producto = "MARKET"
      }
      let activos;
      if (ele.Nprod == 0) {
        activos = "Ninguno"
      } else if (ele.Nprod == 1) {
        activos = ele.Nprod + " Producto, con un saldo a capital a la fecha de " + this.currencyPipe.transform(ele.SaldoKtot, '$ ', 'symbol', '.0-0');
      } else {
        activos = ele.Nprod + " Productos, con un saldo a capital a la fecha de " + this.currencyPipe.transform(ele.SaldoKtot, '$ ', 'symbol', '.0-0');
      }
      file.push({
        EMPRESA: ele.Empresa,
        NUMSOL: ele.NumSol,
        CEDULA: ele.Cedula.trim(),
        NOMBRE_COMPLETO: ele.NombreCompleto.trim(),
        FECHA_SOLICITUD: this.datePipe.transform(ele.FechaSol, "dd/MM/yy"),
        /* MONTO:this.currencyPipe.transform(ele.MontoSol,'$ ','symbol','.0-0'), */
        MONTO: ele.MontoSol,
        PLAZO: ele.Plazo,
        /* CUOTA:this.currencyPipe.transform(ele.TotCuota,'$ ','symbol','.0-0'), */
        CUOTA: ele.TotCuota,
        PRODUCTO: producto,
        FECHA_EST_PRIMER_CUOTA: this.datePipe.transform(ele.Inicio, "dd/MM/yy"),
        FECHA_EST_ULTIMA_CUOTA: this.datePipe.transform(ele.Fin, "dd/MM/yy"),
        ACTIVOS: activos,
        RESPUESTA: "",
        MOTIVO: ""
      })
    });
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate() + '_' + fecha.getHours() + '-' + fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(file);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombre);
    XLSX.writeFile(wb, nombre + '_' + fechaForm + '.xlsx');
  }

  nullString(str) {
    if (str) {
      return str.trim();
    } else {
      return "";
    }
  }

  exportAsExcelFile3(json: any[], nombre: string) {
    let fecha = new Date();
    let file = [];
    json.forEach(ele => {
      let producto;
      if (ele.Tipo == "D") {
        producto = "DINERO"
      } else if (ele.Tipo == "P") {
        producto = "MARKET"
      }
      let activos;
      if (ele.Nprod == 0) {
        activos = "Ninguno"
      } else if (ele.Nprod == 1) {
        activos = ele.Nprod + " Producto, con un saldo a capital a la fecha de " + this.currencyPipe.transform(ele.SaldoKtot, '$ ', 'symbol', '.0-0');
      } else {
        activos = ele.Nprod + " Productos, con un saldo a capital a la fecha de " + this.currencyPipe.transform(ele.SaldoKtot, '$ ', 'symbol', '.0-0');
      }
      file.push({
        EMPRESA: ele.Empresa,
        NUMSOL: ele.NumSol,
        CEDULA: ele.Cedula.trim(),
        NOMBRE_COMPLETO: ele.NombreCompleto.trim(),
        FECHA_SOLICITUD: this.datePipe.transform(ele.FechaSol, "dd/MM/yy"),
        FECHA_APRO_NEG: this.datePipe.transform(ele.AproNegDate, "dd/MM/yy"),
        /* MONTO:this.currencyPipe.transform(ele.MontoSol,'$ ','symbol','.0-0'), */
        MONTO: ele.MontoSol,
        PLAZO: ele.Plazo,
        /* CUOTA:this.currencyPipe.transform(ele.TotCuota,'$ ','symbol','.0-0'), */
        CUOTA: ele.TotCuota,
        PRODUCTO: producto,
        ESTADO: ele.Estado,
        MOTIVO: this.nullString(ele.motivo),
        APRO_USR: this.nullString(ele.AproUsr)
      })
    });
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate() + '_' + fecha.getHours() + '-' + fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(file);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombre);
    XLSX.writeFile(wb, nombre + '_' + fechaForm + '.xlsx');
  }

  updateFileClick() {
    this.uploadFileValue = '';
  }

  onFileChange(ev) {
    const file = ev.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event: any) => {
      try {
        const data = new Uint8Array(event.target.result);

        const workBook = XLSX.read(data, { type: 'array' });

        let cedulas = [];

        for (const name of workBook.SheetNames) {
          const sheet = workBook.Sheets[name];

          const registros: any[] = XLSX.utils.sheet_to_json(sheet, {
            defval: ''
          });

          cedulas = registros
            .map(row => {
              const columna = Object.keys(row).find(
                key => key.trim().toLowerCase() === 'cedula'
              );

              return columna ? String(row[columna]).trim() : '';
            })
            .filter(cedula => /^\d+$/.test(cedula));

          if (cedulas.length > 0) {
            console.log('Hoja utilizada:', name);
            break;
          }
        }

        this.cedulasExist = [];
        this.cedulasString = '';
        this.generarShow = false;

        if (cedulas.length === 0) {
          alert('El archivo no contiene cédulas válidas.');
          return;
        }

        this.cedulasExist = [...new Set(cedulas)];

        this.cedulasString = this.cedulasExist.join(', ');

        this.generarShow = true;
      } catch (error) {
        console.error('Error al procesar Excel:', error);
        alert('No fue posible procesar el archivo.');
      }
    };

    reader.readAsArrayBuffer(file);
  }

  updateFilterHtml(event) {
    this.updateFilter(event.detail.value);
  }

  updateFilter(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtLiq = this.Liq.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || !val);
    });
  }

  updateFilterHtml2(event) {
    this.updateFilter2(event.detail.value);
  }

  updateFilter2(event: string) {
    const valor = String(event || '').trim();

    if (!valor) {
      this.filtHisLiq = [...this.hisLiq];
      return;
    }

    const valores = valor.split(/[\s,;]+/).map(v => v.trim()).filter(Boolean);

    // MULTIPLES VALORES
    if (valores.length > 1) {
      const cedulasSet = new Set(valores);

      this.filtHisLiq = this.hisLiq.filter((d) =>
        cedulasSet.has(String(d.Cedula ?? '').trim())
      );

      return;
    }

    // BUSQUEDA NORMAL
    const val = valores[0].toLowerCase();

    this.filtHisLiq = this.hisLiq.filter((d) => {
      return (
        String(d.Cedula ?? '').toLowerCase().includes(val) ||
        String(d.Nombre ?? '').toLowerCase().includes(val) ||
        String(d.NumSol ?? '').toLowerCase().includes(val) ||
        String(d.IdEmpresa ?? '').toLowerCase().includes(val)
      );
    });
  }

  updateFilterHtml3(event) {
    this.updateFilter3(event.detail.value);
  }

  updateFilter3(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtPendSol = this.pendSol.filter((d) => {
      return (d.Empresa.toLowerCase().indexOf(val) !== -1 || d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || !val);
    });
    this.filtPendSol.sort((a, b) => b.NumSol - a.NumSol);
  }

  /* updateFilterHtml4(event) {
    this.updateFilter4(event.detail.value);
  } */

  sinTildes(entrada) {
    if (entrada == null) { entrada = ""; }
    let input = entrada.toString();
    var tittles = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç´";
    var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc ";
    for (var i = 0; i < tittles.length; i++) {
      input = input.replace(tittles.charAt(i), original.charAt(i)).toLowerCase().trim();
    };
    return input;
  }

  estadosSelectValue = [2, 3, 5, 7, 10];
  updateFilter4() {
    console.log('busqueda4: ', this.busqueda4);
    console.log('estadosSelectValue: ', this.estadosSelectValue);

    const val = this.sinTildes(this.busqueda4);

    // filter our data
    let filter1 = this.hisSol.filter((d) => {
      return (
        this.sinTildes(d.Empresa).indexOf(val) !== -1
        || this.sinTildes(d.Cedula).indexOf(val) !== -1
        || this.sinTildes(d.NombreCompleto).indexOf(val) !== -1
        || this.sinTildes(d.NumSol).indexOf(val) !== -1
        || this.sinTildes(d.IdEmpresa).indexOf(val) !== -1
        || this.sinTildes(d.Estado).indexOf(val) !== -1
        || !val);
    });

    let filter2 = [];
    filter1.forEach(f => {
      this.estadosSelectValue.forEach(e => {
        if (f.IdEstado == e) {
          filter2.push(f);
        }
      });
    });

    this.filtHisSol = filter2;
  }

  updateFilterHtml8(event) {
    this.updateFilter8(event.detail.value);
  }

  updateFilter8(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.EncReportesFilt = this.EncReportes.filter((d) => {
      return (d.IdReporte.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || d.Empresa.toLowerCase().indexOf(val) !== -1 || !val);
    });
    console.log('EncReportesFilt: ', this.EncReportesFilt);
  }

  updateFilterHtml9(event) {
    this.updateFilter9(event.detail.value);
  }

  updateFilter9(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.DetReporteFilt = this.DetReporte.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || !val);
    });
  }

  InputCedulasChang(event) {
    let cedulas = event.detail.value;
    console.log('cedulas: ', cedulas)
    let cedulasArr = cedulas.split(',')
    console.log('Cedulas split: ', cedulasArr)
    this.cedulasExist = [];
    this.cedulasString = "";
    cedulasArr.forEach(cedula => {
      if (cedula.trim() != "") {
        this.cedulasString = this.cedulasString + cedula.trim() + ", ";
        this.cedulasExist.push({ cedula: cedula.trim() });
      }
    });
    if (this.cedulasExist.length > 0) { this.generarShow = true; }
    console.log('cedulasExist: ', this.cedulasExist)
  }

  getClientesForConv() {
    return new Promise((resolve, reject) => {
      console.log('Obteniendo usuarios del convenio...');

      const body = {
        idempresa: this.user.IdEmpresa,
        rol: this.user.IdRol
      };

      this.http.post(environment.urlApi + 'getclientesforconv', body).subscribe({
        next: (res: any) => {
          this.ClientesConv = res.creditos || [];
          console.log('Clientes por Convenio: ', this.ClientesConv);
          
          resolve("ok");
        }, error: (error) => {
          console.error('Error obteniendo usuarios del convenio:', error);
          this.ClientesConv = [];
          reject(error);
        }
      })
    })
  }

  async getLiqOnly() {
    this.Liq = [];
    this.filtLiq = [];
    this.descargaShow = true;
    this.count = 0;

    let body = {
      Usuario: this.user.Usuario.trim(),
      data: this.usersForLiq
    }

    console.log('Obteniendo Liquidaciones...');
    this.presentToast('Obteniendo Liquidaciones, por favor espera...Tiempo aproximado (' + this.usersForLiq.length + ' seg.)');

    console.log('data liquidaciones', this.usersForLiq);
    
    this.http.post(environment.urlApi + 'getliquidmasivasonlyconvenios', body).subscribe((res: any) => {
      console.log('res: ', res);
      this.Liq = res;
      this.filtLiq = res;
      this.updateFilter(this.busqueda1.trim());
      this.descargaShow = false;
    })

    this.descargaShow = false;
  }

  getUsersForLiq() {
    console.log('Obteniendo usuarios para liquidar...');
    this.generarShow = false;
    this.presentLoading('Obteniendo usuarios para liquidar...');
    this.apiOnReq = true;
    let body = {
      Hoja1: this.cedulasExist
    };
    this.http.post(environment.urlApi + 'getusersforliq', body).subscribe((res: any) => {
      console.log('res: ', res);
      this.usersForLiq = res.found;
      this.cedulasNotFound = res.notfound;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      if (this.cedulasNotFound.length > 0) {
        this.cedulasNotFoundString = "";
        this.cedulasNotFound.forEach(cedula => {
          this.cedulasNotFoundString = this.cedulasNotFoundString + cedula + ", ";
        });
      }
      if (this.usersForLiq.length > 0) {
        this.getLiqOnly();
      }
    })
  }

  getModoRecarga() {
    this.http.get(environment.URLDCARD + `autogestion/tipo-recarga/${this.user.IdEmpresa}`, {
      headers: {
        'x-session-token': `${environment.DCARDAPIKEY}`
      }
    }).subscribe((res: any) => {
      console.log('res modalidad: ', res);
      this.modoRecarga = res.modoRecarga;
    })
  }

  async getUsersForLiq2() {
    await this.presentLoading('Preparando todo, por favor espera...');
    this.apiOnReq = true;
    await this.getClientesForConv();

    console.log('Obteniendo usuarios para liquidar2...');

    this.generarShow = false;
    this.usersForLiq = [];
    this.cedulasNotFound = [];
    this.cedulasNotFoundString = "";

    this.cedulasExist.forEach(cedula => {
      const cedulaActual = String(cedula ?? '').trim();

      if (!cedulaActual) {
        return;
      }

      const usuario = this.ClientesConv.filter(cliente => String(cliente.Cedula ?? '').trim() === cedulaActual);

      if (usuario.length > 0) {
        usuario.forEach(usr => {
          this.usersForLiq.push(usr);
        });

      } else {
        this.cedulasNotFound.push(cedulaActual);
        this.cedulasNotFoundString = this.cedulasNotFoundString + cedulaActual + ", ";
      }
    });

    console.log('usersForLiq: ', this.usersForLiq);

    this.loading.dismiss();
    this.apiOnReq = false;

    clearTimeout(this.temporizador);

    if (this.usersForLiq.length > 0) {
      this.getLiqOnly();
    }
  }

  genLiq() {
    console.log('Obteniendo Liquidaciones...');

    this.presentLoading('Obteniendo Liquidaciones, por favor espera...Tiempo aproximado (' + this.cedulasExist.length + ' seg.)');
    this.apiOnReq = true;
    let body = {
      Hoja1: this.cedulasExist
    };
    this.http.post(environment.urlApi + 'getliquidmasivas', body).subscribe((res: any) => {
      console.log('res: ', res);
      this.Liq = res.found;
      this.filtLiq = res.found;
      this.cedulasNotFound = res.notfound;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter(this.busqueda1.trim());
      if (this.cedulasNotFound.length > 0) {
        this.cedulasNotFoundString = "";
        this.cedulasNotFound.forEach(cedula => {
          this.cedulasNotFoundString = this.cedulasNotFoundString + cedula + ", ";
        });
      }
    })
  }

  async loginFun() {
    console.log('Validando credenciales por favor espera...');
    await this.presentLoading('Validando credenciales por favor espera...');
    this.apiOnReq = true;
    let body = {
      usuario: this.usuario.trim(),
      clave: this.clave.trim()
    };
    this.http.post(environment.urlApi + 'loginnewconv', body).subscribe((res: any) => {

      if (res.res == "Logeado") {
        this.login = true;
        this.user = res.usuario;
        console.log(this.user)
        if (this.user.convenios != null && this.user.convenios != '') { this.empresasGrupo = JSON.parse(this.user.convenios); console.log(this.empresasGrupo); }
        this.IdEmpresa = this.user.IdEmpresa;
        this.Correo = this.user.Correo;
        this.router.navigate(['/dashboard']);
        this.getEmpresas1();
        this.getModoRecarga();
        this.getEstados();
        this.getCodBancos();
        this.getBanner();
        this.getConvInfo();

        /* this.getAllSol(); */
        this.presentToast('Bienvenido ' + this.user.Nombres);
        Storage.set({
          key: 'loginNewConvDen',
          value: JSON.stringify({
            login: this.login,
            user: this.user.Usuario,
            correo: this.user.Correo
          })
        })
          .then((res) => {
            console.log('informacion de usuario guardada correctamente ', res);
          })
          .catch((err) => {
            console.log('Error al guardar informacion de usuario ', err);
          });
        this.usuario = ""; this.clave = "";
      }
      else {
        alert(res.res);
      }
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  logOut() {
    /* this.menu.close('end'); */
    this.IdEmpresa = 0;
    this.Correo = '';
    this.login = false;
    Storage.remove({ key: 'loginNewConvDen' }).then(() => {
      window.location.reload();
      /* this.router.navigate(['/']); */
    });
  }

  recuperarClave() {
    console.log('correo: ', this.correo);
    console.log('Enviando correo...');
    this.presentLoading('Enviando correo...');
    this.apiOnReq = true;
    let body = {
      email: this.correo
    };
    this.http.post(environment.urlApi + 'recuperarclaveconv', body).subscribe((res: any) => {
      console.log(res);
      this.presentToast(res.res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })

  }

  async cambiarClave() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Cambio de contraseña!',
      inputs: [
        {
          name: 'pass',
          type: 'password',
          placeholder: 'Ingresa Clave anterior'
        },
        {
          name: 'newpass',
          type: 'password',
          placeholder: 'Ingresa nueva clave'
        },
        {
          name: 'confnewpass',
          type: 'password',
          placeholder: 'Confirma nueva clave'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (alertData) => {
            console.log('Confirm Ok');
            this.cambiarClaveApi(alertData)
          }
        }
      ]
    });

    await alert.present();
  }

  cambiarClaveApi(data) {
    console.log('Alert: ', data);
    console.log('Clave: ', data.pass);
    console.log('New Clave: ', data.newpass);
    console.log('Conf New Clave: ', data.confnewpass);
    if (data.newpass.trim() == data.confnewpass.trim()) {

      console.log('Actualizando clave...');
      this.presentLoading('Actualizando clave...');
      this.apiOnReq = true;
      let body = {
        usuario: this.user.Usuario,
        clave: data.pass,
        newclave: data.newpass
      };
      this.http.post(environment.urlApi + 'changepassnewconv', body).subscribe((res: any) => {
        console.log(res);
        this.presentToast(res.res + "" + res.mensaje)
        this.loading.dismiss();
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
      })

    } else {
      alert('Por favor confirma bien la nueva contraseña')
    }

  }

  async getLiqHis() {
    console.log('Obteniendo historial de liquidaciones...');
    await this.presentLoading('Obteniendo información de pagos...');
    this.apiOnReq = true;
    let body = {
      usuario: this.user.Usuario
    };
    this.http.post(environment.urlApi + 'getliqhisconv', body).subscribe((res: any) => {
      console.log('res: ', res);
      res.sort((a, b) => new Date(b.FechaGen).getTime() - new Date(a.FechaGen).getTime());
      this.hisLiq = res;
      this.filtHisLiq = res;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter2(this.busqueda2.trim());
    })
  }

  calcSol() {
    /* this.pendSol = []; */
    /* this.filtPendSol = []; */
    this.hisSol = [];
    this.filtHisSol = [];
    this.allSol.forEach(sol => {
      let Prodxcc = this.allSol.filter(s => s.IdEstado.trim() == '3' && s.Cedula.trim() == sol.Cedula.trim())
      sol.Nprod = Prodxcc.length
      let saldoktot = 0;
      Prodxcc.forEach(prod => { saldoktot = saldoktot + prod.SaldoK });
      sol.SaldoKtot = saldoktot
      /* if (sol.IdEstado.trim() == '8') {
        sol.aprobado=false;sol.negado=false;sol.motivo="";
        this.pendSol.push(sol);
        this.filtPendSol.push(sol);
      } */
      if (sol.AprobadoRH == 1 || sol.IdEstado.trim() != '8') {
        this.hisSol.push(sol);
        this.filtHisSol.push(sol);
      }
    });
    this.updateFilter3(this.busqueda3);
    this.updateFilter4();
    console.log('allSol2: ', this.allSol);
    /* console.log('pendSol: ', this.pendSol); */
    console.log('hisSol: ', this.hisSol);
  }

  async getAllSol() {
    if (!this.apibusy) {
      this.apibusy = true;
      console.log('Obteniendo Solicitudes...');
      this.spinnerEn = true;
      let body;
      if (this.user.IdRol != 10) {
        if (this.empresasGrupo.length == 0) {
          body = {
            idempresa: this.user.IdEmpresa,
            rol: this.user.IdRol
          };
        } else {
          body = {
            idempresa: this.IdEmpresa,
            rol: this.user.IdRol
          };
        }
      } else {
        if (!this.IdEmpresa) {
          this.presentToast('Selecciona empresa por favor');
          this.spinnerEn = false;
          this.enviando = false;
          this.apibusy = false;
        }
        else if (this.IdEmpresa == 0) {
          body = {
            idempresa: this.IdEmpresa,
            rol: 10
          };
        } else {
          body = {
            idempresa: this.IdEmpresa,
            rol: 100
          };
        }
      }
      if (body) {
        console.log('body: ', body);
        this.http.post(environment.urlApi + 'getsolforconv', body).subscribe((res: any) => {
          console.log('******res: ', res);
          res.forEach(credito => {
            let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
            credito.Empresa = empresa.Nombre.trim();
            if (credito.IdEstado.trim() == '2' && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
            let estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado)
            credito.Estado = estado.Descripcion
          });

          this.allSol = res;
          this.allSol.sort((a, b) => b.NumSol - a.NumSol);
          this.spinnerEn = false;
          this.calcSol();
          this.enviando = false;
          this.apibusy = false;
        })
      }
    } else {
      this.presentToast('Espera por favor');
    }
  }


  async getPendSol() {
    if (!this.apibusy) {
      this.apibusy = true;
      console.log('Obteniendo Solicitudes...');
      this.spinnerEn = true;
      let body;
      if (this.user.IdRol != 10) {
        if (this.empresasGrupo.length == 0) {
          body = {
            idempresa: this.user.IdEmpresa,
            rol: this.user.IdRol
          };
        } else {
          body = {
            idempresa: this.IdEmpresa,
            rol: this.user.IdRol
          };
        }
      } else {
        if (!this.IdEmpresa) {
          this.presentToast('Selecciona empresa por favor');
          this.spinnerEn = false;
          this.enviando = false;
          this.apibusy = false;
        }
        else if (this.IdEmpresa == 0) {
          body = {
            idempresa: this.IdEmpresa,
            rol: 10
          };
        } else {
          body = {
            idempresa: this.IdEmpresa,
            rol: 100
          };
        }
      }
      if (body) {
        console.log('body: ', body);
        this.http.post(environment.urlApi + 'getsolforconv2', body).subscribe((res: any) => {
          console.log('******res: ', res);
          let pendSolArrayTemp = res;
          res.forEach(s => {
            if (s.FrmVin > 0) {
              s.Formulario = 'https://denario.com.co/user.html?' + s.Cedula;
            }
            s.TotValCuotasTOT = s.TotCuota + s.TotValCuotas;
            /* let totValCuotasTemp = 0;
            pendSolArrayTemp.forEach(p => {
              if(p.Cedula == s.Cedula){
                totValCuotasTemp = totValCuotasTemp + p.TotCuota
              }
            });
            s.TotValCutoas = totValCuotasTemp; */
          });
          this.pendSol = res;
          this.filtPendSol = this.pendSol;
          this.updateFilter3(this.busqueda3);
          this.spinnerEn = false;
          this.enviando = false;
          this.apibusy = false;
        })
      }
    } else {
      this.presentToast('Espera por favor');
    }
  }


  getEstados() {
    console.log('Obteniendo estados...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getestados', body).subscribe((res: any) => {
      this.estados = res;
      console.log('Estados: ', this.estados);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }

  getCodBancos() {
    console.log('Obteniendo codigos bancos...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getcodbanks', body).subscribe((res: any) => {
      this.bancos = res;
      console.log('Bancos: ', this.bancos);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }

  getInfoBank(cedula) {
    console.log('Obteniendo informacion de bancos...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {
      cedula: cedula
    };
    this.http.post(environment.urlApi + 'getinfobank', body).subscribe((res: any) => {
      this.EmpToEdit = Object.assign(this.EmpToEdit, res)
      console.log('EmpToEdit: ', this.EmpToEdit);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }


  aprobarAll(ev) {
    let respuesta = ev.detail.checked
    if (!respuesta) {
      console.log('aprobarAll: ', respuesta);
      this.pendSol.forEach(sol => {
        if (!sol.negado) {
          sol.aprobado = respuesta;
        }
      });
    } else {
      console.log('aprobarAll: ', respuesta);
      this.filtPendSol.forEach(sol => {
        if (!sol.negado) {
          sol.aprobado = respuesta;
        }
      });
    }
    this.enBtnEnvAprob = true;
  }

  async negarSol(ev: any, sol) {
    console.log(sol);
    let index = this.pendSol.findIndex(s => s.NumSol == sol.NumSol);
    if (sol.negado && !sol.aprobado) {
      this.pendSol[index].motivo = "Otros";
      this.solRechazo = sol;
      const popover = await this.popoverController.create({
        component: NegarPage,
        cssClass: 'popoverStyle',
        event: ev,
        translucent: true,
        componentProps: {},
        mode: 'ios'
      });
      await popover.present();
    }
    this.pendSol[index].aprobado = false;
    if (!sol.negado) { this.pendSol[index].motivo = ""; }
    this.enBtnEnvAprob = true;
  }

  async editEmp(ev: any, sol) {
    this.EmpToEdit = sol;
    console.log(this.EmpToEdit);
    this.getInfoBank(this.EmpToEdit.Cedula);
    let index = this.pendSol.findIndex(s => s.NumSol == sol.NumSol);
    const popover = await this.popoverController.create({
      component: EditEmpPage,
      cssClass: 'popoverStyle',
      event: ev,
      translucent: true,
      componentProps: {},
      mode: 'ios'
    });
    await popover.present();
  }

  aprobarChange(sol) {
    this.enBtnEnvAprob = true;
    let index = this.pendSol.findIndex(s => s.NumSol == sol.NumSol);
    this.pendSol[index].negado = false;
    this.pendSol[index].motivo = ''
  }

  rechazarMotivo() {
    this.popoverController.dismiss();
    let index = this.pendSol.findIndex(s => s.NumSol == this.solRechazo.NumSol);
    this.pendSol[index].motivo = this.motivoRechazo;
  }

  cancelarMotivo() {
    this.popoverController.dismiss();
    let index = this.pendSol.findIndex(s => s.NumSol == this.solRechazo.NumSol);
    this.pendSol[index].negado = false;
    this.pendSol[index].motivo = '';
  }

  enviarRes() {
    this.respuestas = [];
    this.pendSol.forEach(sol => {
      if (!(!sol.negado && !sol.aprobado)) {
        this.respuestas.push(sol);
      }
    });
    console.log('respuestas: ', this.respuestas);
    this.enviaResAlert();
  }

  async enviaResAlert() {
    let total = this.pendSol.length;
    let totres = this.respuestas.length
    let aprobados = 0;
    let negados = 0;
    this.respuestas.forEach(sol => {
      if (sol.aprobado) { aprobados = aprobados + 1 }
      if (sol.negado) { negados = negados + 1 }
    });
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Por favor confirma!',
      subHeader: "Respuestas: " + totres,
      message: "Aprobados: " + aprobados + " - Negados: " + negados,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            if (totres > 0) {
              this.enviarResApi();
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async enviarResApi() {
    console.log("respuestas: ", this.respuestas)
    console.log('Subiendo Respuestas...');
    this.enviando = true;
    this.spinnerResEn = true;
    let ressub = 0;
    let cctosms = [];
    let cctosmsmk = [];
    for (let res of this.respuestas) {
      let body = {
        cedula: res.Cedula,
        numsol: res.NumSol,
        usuario: this.user.Usuario.trim(),
        motivo: res.motivo
      };
      if (res.aprobado && !res.negado) {
        let subap = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'aprobarrrhhNew', body).subscribe((resp: any) => {
            console.log('Subido aprobado: ', res);
            ressub = ressub + 1;
            if (res.Tipo == "P") {
              cctosmsmk.push({
                NumSol: res.NumSol,
                Telefono: resp.Celular.trim(),
                Cedula: res.Cedula
              })
            }
            resolve('ok');
          })
        });
        await subap;
      } else if (!res.aprobado && res.negado) {
        let subneg = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'negarrrhhnew', body).subscribe((resp: any) => {
            console.log('Subido negado: ', res);
            ressub = ressub + 1;
            cctosms.push({
              NumSol: res.NumSol,
              Telefono: resp.Celular.trim()
            })
            resolve('ok');
          })
        });
        await subneg;
      }
    }
    this.spinnerResEn = false;
    this.getPendSol();
    if (this.respuestas.length != ressub) {
      let dif = this.respuestas.length - ressub;
      alert('no se subieron ' + dif + ' respuestas');
    } else {
      this.presentToast('Respuestas subidas correctamente!');
    }
    if (cctosms.length > 0) {
      let body2 = {
        Telefono: cctosms
      }
      console.log('body2: ', body2);
      this.http.post(environment.urlApi + 'smsnorrhh', body2).subscribe((resp: any) => {
        console.log('Mensajes enviados: ', resp);
      })
    }

    if (cctosmsmk.length > 0) {
      let body2 = {
        Telefono: cctosmsmk
      }
      console.log('body2: ', body2);
      this.http.post(environment.urlApi + 'sendsmsformmk', body2).subscribe((resp: any) => {
        console.log('Mensajes enviados: ', resp);
      })
    }

  }

  async getEncReporte() {
    console.log('Obteniendo encabezado de reportes..');
    await this.presentLoading('Obteniendo encabezado de reportes..');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getencreportes', body).subscribe((res: any) => {
      let restemp = [];
      res.tabla.forEach(rep => {
        rep.DifRec = rep.ValorRep - rep.ValorRec;
        if (this.user.IdRol != 10) {
          if (this.empresasGrupo.length == 0) {
            if (this.user.IdEmpresa == rep.IdEmpresa) {
              restemp.push(rep);
            }
          } else {
            for (let i = 0; i < this.empresasGrupo.length; i++) {
              if (this.empresasGrupo[i].IdEmpresa == rep.IdEmpresa) {
                restemp.push(rep);
              }
            }
          }
        } else {
          restemp.push(rep);
        }
      });
      this.EncReportes = restemp;
      this.EncReportesFilt = restemp;
      console.log('EncReportes: ', this.EncReportes);
      this.updateFilter8(this.busqueda8);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  async getDetReporte(reporte) {
    this.showDetReporte = true;
    this.encReporte = reporte;
    console.log('Obteniendo detalles del reporte..');
    await this.presentLoading('Obteniendo detalles del reporte..');
    this.apiOnReq = true;
    let body = {
      idreporte: reporte.IdReporte
    };
    this.http.post(environment.urlApi + 'getdetreporte', body).subscribe((res: any) => {
      res.tabla = res.tabla.sort((a, b) => b.NumSol - a.NumSol);
      this.DetReporte = res.tabla;
      this.DetReporteFilt = res.tabla;
      console.log('DetReporte: ', this.DetReporte);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter9(this.busqueda9);
    })
  }


  /* getBanner(){
    console.log('Obteniendo banner...');
    let body={};
    this.http.post(environment.urlApi + 'getbannerconv',body).subscribe((res:any)=>{
      console.log('Allbanners: ',res);
      res.forEach(ban => {
        let convenios = [];
        let usuarios = [];
        let convExist;
        let usrExist;
        if(ban.Estado==1){
          if(ban.Convenios.trim() == "0"){ 
            if(ban.Usuarios.trim() == "0"){
              this.banner.push(ban);
            }else{
              usuarios = ban.Usuarios.split(",");
              usrExist = usuarios.findIndex(a=>a.trim()==this.user.Usuario.trim())
              if(usrExist>=0){this.banner.push(ban);}
            }
          }else{
            convenios = ban.Convenios.split(",");
            convExist = convenios.findIndex(a=>a.trim()==this.user.IdEmpresa.toString())
            console.log('convenios: ',convenios,"-",convExist);
            if(convExist>=0){
              if(ban.Usuarios.trim() == "0"){
                this.banner.push(ban);
              }else{
                usuarios = ban.Usuarios.split(",");
                usrExist = usuarios.findIndex(a=>a.trim()==this.user.Usuario.trim())
                if(usrExist>=0){this.banner.push(ban);}
              }
            }
          }  
        }
      });
      console.log('Banner: ',this.banner);
    })
  } */

  
  getBanner() {
    console.log('Obteniendo banner...');
    let body = {};
    this.http.post(environment.urlApi + 'getmainbanner', body).subscribe((res: any) => {
      console.log('bannerMain: ', res);
      this.banner = [];
      res.forEach(ban => {
        let convenios = [];
        let usuarios = [];
        let convExist;
        let usrExist;
        if (ban.Estado == 1 && ban.Conv == 1) {
          if (ban.Convenios.trim() == "0") {
            if (ban.Usuarios.trim() == "0") {
              this.banner.push(ban);
            } else {
              usuarios = ban.Usuarios.split(",");
              usrExist = usuarios.findIndex(a => a.trim() == this.user.Usuario.trim())
              if (usrExist >= 0) { this.banner.push(ban); }
            }
          } else {
            convenios = ban.Convenios.split(",");
            convExist = convenios.findIndex(a => a.trim() == this.user.IdEmpresa.toString())
            console.log('convenios: ', convenios, "-", convExist);
            if (convExist >= 0) {
              if (ban.Usuarios.trim() == "0") {
                this.banner.push(ban);
              } else {
                usuarios = ban.Usuarios.split(",");
                usrExist = usuarios.findIndex(a => a.trim() == this.user.Usuario.trim())
                if (usrExist >= 0) { this.banner.push(ban); }
              }
            }
          }
        }
      });
      this.banner = this.banner.sort((a, b) => a.Ord - b.Ord);
      console.log('Banner: ', this.banner);
    })
  }


  getConvInfo() {
    console.log('Obteniendo datos de dashboard...');
    let body = {
      idempresa: this.user.IdEmpresa
    };
    this.http.post(environment.urlApi + 'getinfoconv', body).subscribe((res: any) => {
      this.infoConv = res;
      console.log('infoConv: ', this.infoConv);
    })
  }

  editEmpInfoBank() {
    let index = this.bancos.findIndex(s => s.Cod == this.EmpToEdit.BancoCodigo);
    console.log('index: ', index);
    if (index >= 0) {
      this.EmpToEdit.Banco = this.bancos[index].Banco;
      let body = {
        cedula: this.EmpToEdit.Cedula,
        banco: this.EmpToEdit.Banco,
        bancocodigo: this.EmpToEdit.BancoCodigo,
        tipocuenta: this.EmpToEdit.TipoCuenta,
        cuentabancaria: this.EmpToEdit.CuentaBancaria,
      };
      console.log('body: ', body);
      this.http.post(environment.urlApi + 'updateinfobank', body).subscribe((res: any) => {
        console.log('res: ', res);
        this.presentToast("Información bancaria actualizada correctamente")
        this.popoverController.dismiss();
      }, (err) => {
        alert('Error al actualizar información bancaria: ' + err);
        this.popoverController.dismiss();
      })
    } else {
      alert('Por favor selecciona Banco');
    }
  }

  customAlertOptions: any = {
    translucent: true,
    cssClass: 'alertStyle1',
  };

  async downloadPagare(numsol) {
    console.log('NumSol: ', numsol);
    console.log('Obteniendo Url de pagare...');
    this.apiOnReq = true;
    let body = {
      numsol: numsol
    };
    this.http.post(environment.urlApi + 'geturlpagare', body).subscribe((res: any) => {
      console.log('geturlpagare: ', res);
      if (res.UrlPagare) {
        let pagare = res.UrlPagare
        console.log('Pagare: ', pagare);
        window.location.href = pagare;
      } else {
        alert('No se encontró pagaré');
      }
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
    await this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    if (!this.apiOnReq) { this.loading.dismiss(); }
  }

  async informeSaldosMTI() {
    console.log('Obteniendo informe de saldos para MTI...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getsaldosthomas', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log('getsaldosthomas: ', res);
      this.exportAsExcelFile(res, 'InfoSaldosThomas');
    },
      (err) => {
        if (this.loading) { this.loading.dismiss() };
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        console.log('getsaldosthomas Error: ', err);
        alert(JSON.stringify(err));
      })
    await this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    if (!this.apiOnReq) { this.loading.dismiss(); }
  }

  verRol(funcion: string) {

    if (this.user) {
      if (this.user.IdRol == 10 || this.user.IdRol == 100) { //super usuarios

        if (funcion == 'porEmpresa' && this.user.IdRol == 100) {
          return false;
        } else {
          return true;
        }
      } else {
        switch (funcion) {
          case 'AprRech': if (this.user.IdRol == 300) { return true; } else { return false; }
          case 'Liq': if (this.user.IdRol == 200) { return true; } else { return false; }
          case 'Sols': if (this.user.IdRol == 100) { return true; } else { return false; }
          case 'Viajes': if (this.user.IdRol != 400 && this.user.IdRol != 410) { return true; } else { return false; }
          // case 'usuarios': return usuariosPermitidos.includes(this.user.Usuario)
          default:
            return false;
        }
      }
    }
  }

  superAdmin() {
    let usuariosPermitidos = ["jhon.hernandez", "miguel.mendez", "lina.cuellar.denario", "Nicolas.Caicedo", "juan.penagos"]
    return usuariosPermitidos.includes(this.user.Usuario)
  }

  async req(tipo, path, body = {}, mssLoading, loadingEn = true) {
    console.log(body);
    if (!this.apiOnReq) {
      this.apiOnReq = true;
      if (loadingEn) { await this.presentLoading(mssLoading); }
      return new Promise((resolve, reject) => {
        switch (tipo.toLowerCase()) {
          case "get":
            this.http.get(environment.urlApi + path, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          case "post":
            this.http.post(environment.urlApi + path, body, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          default:
            break;
        }
      })
    } else {
      this.presentToast('Servicio ocupado, por favor espera');
    }
  }


  PuedeVerSeccionAdminDcard(usuario: string) {
    const usuariosPermitidos = ["miguel.mendez", "Nicolas.Caicedo","lina.cuellar.denario", "juan.penagos","juan.duran","alejandro.hernandez.Dcard"];
    return usuariosPermitidos.includes(usuario);
  }

  PuedeVerSeccionFacturacion(usuario: string) {
    const usuariosPermitidos = ["miguel.mendez", "Nicolas.Caicedo", "juan.penagos","lina.cuellar.denario","juan.duran","patricia.garcia.puntos","patricia.garcia.viajes","vanessa.alzate.facturacion"];
    return usuariosPermitidos.includes(usuario);
  }

}
